import { IsNotEmpty } from 'class-validator';

import { ERROR_MESSAGE } from './constants';
import { IsPhoneNumber } from './decorator';

export class PhoneNumberValidation {
  @IsPhoneNumber({
    message: ERROR_MESSAGE.IS_NOT_KOREAN_NUMBER,
  })
  @IsNotEmpty({
    message: ERROR_MESSAGE.IS_NOT_EMPTY,
  })
  phone: string;

  verifyCode: string;

  countryCode: string;

  static isPhoneNumberValidation(object: unknown): object is PhoneNumberValidation {
    return (
      typeof object === 'object' && object !== null && 'phone' in object && 'countryCode' in object
    );
  }
}
